import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface WarningData {
  message: string;
  hideImage: boolean;
  proceedBtnLabel: string;
  cancelBtnLabel: string;
  header: string;
  image: string;
  onProceed: () => void;
  onDiscard: () => void;
}

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
  standalone: false,
})
export class WarningDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WarningData,
  ) {}

  ngOnInit(): void {}

  proceed() {
    this.data.onProceed();
    this.dialogRef.close();
  }

  cancel() {
    this.data.onDiscard();
    this.dialogRef.close();
  }
}
